import { AVIS_VISUALITZACIO_OBTENIR_METEORS_EN_CURS, 
         AVIS_VISUALITZACIO_OBTENIR_METEORS_FINALITZAT,
         AVIS_INICIALITZAR } from '../../actions/actionTypes';

const ESTAT_INICIAL = false;

const peticioMeteorsEnCurs = (state = ESTAT_INICIAL, action) => {

    switch(action.type) {
        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_VISUALITZACIO_OBTENIR_METEORS_FINALITZAT:
            return ESTAT_INICIAL;

        case AVIS_VISUALITZACIO_OBTENIR_METEORS_EN_CURS:
            return true;

        default:
            return state;
    }
};

export default peticioMeteorsEnCurs;


// WEBPACK FOOTER //
// ./src/reducers/avis/peticioMeteorsEnCurs.js